import React from 'react';
import styled from 'styled-components';

interface EmptyListProps {
  message: string;
}

const EmptyList: React.FC<EmptyListProps> = ({ message }) => {
  return (
    <EmptyListContainer>
      No {message} found
    </EmptyListContainer>
  );
};

export default EmptyList;

const EmptyListContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  ${({ theme }) => theme.typography.Body_03_2};
  color: ${({ theme }) => theme.colors.color_Gray_05};
`;
